import React from 'react';
import SEO from './components/SEO';
import './web-mcp-support.css';

const WebMcpSupport = () => {
    const title = 'Web MCP Support | ai-BIBLE';
    const description = 'Learn how AI agents can use WebMCP to search Scripture and ai-BIBLE resources.';
    document.title = title;

    return (
        <main className="webmcp-page">
            <SEO canonical="https://www.ai-bible.com/web-mcp-support" title={title} description={description} />
            <div className="webmcp-frame">
                <header className="webmcp-hero">
                    <p className="webmcp-eyebrow">Search with AI agents</p>
                    <h1>Web MCP Support</h1>
                    <p>WebMCP lets compatible AI agents discover and use tools provided by a web page. On ai-BIBLE, an agent can search Scripture and related study resources directly through the search page.</p>
                    <a className="webmcp-button" href="/search">Get started with search <span aria-hidden="true">→</span></a>
                </header>

                <section className="webmcp-card" aria-labelledby="webmcp-how-title">
                    <h2 id="webmcp-how-title">How to use it</h2>
                    <ol>
                        <li>Open <a href="/search">ai-BIBLE Search</a> in a browser or agent that supports WebMCP.</li>
                        <li>Ask the agent what you want to find, such as <em>“Find New Testament verses about loving your enemies.”</em></li>
                        <li>The agent can call the page&apos;s search tool and return matching results with links to read each passage in context.</li>
                    </ol>
                    <p>WebMCP tools are available to the agent while it is on the search page. They are not a separate chat assistant or a standalone MCP server.</p>
                </section>

                <section className="webmcp-card" aria-labelledby="webmcp-tools-title">
                    <h2 id="webmcp-tools-title">Tools available on the search page</h2>
                    <ul>
                        <li><strong>Search the Bible:</strong> find verses by word or phrase and optionally narrow results to a testament or book group.</li>
                        <li><strong>Search ai-BIBLE:</strong> search verses alongside perspectives, devotional plans, people, and places.</li>
                    </ul>
                </section>

                <section className="webmcp-card" aria-labelledby="webmcp-setup-title">
                    <h2 id="webmcp-setup-title">Trying it in Chrome</h2>
                    <p>WebMCP is an experimental browser feature. For local testing in Chrome, enable the <code>enable-webmcp-testing</code> flag at <code>chrome://flags/#enable-webmcp-testing</code>, relaunch Chrome, then open the search page. A compatible agent or WebMCP inspection tool can then discover and run the page&apos;s tools.</p>
                </section>
            </div>
        </main>
    );
};

export default WebMcpSupport;
